import LinkToCustomScriptDoc from '../links/LinkToCustomScriptDoc'
import {
  Header,
  Paragraph
} from '@eggplant/pattern-library'

const TestConfigCustomScriptsDescription = () =>
  <>
    <Header
      hasNoTopMargin
      rank={4}
    >
      Custom scripts
    </Header>
    <Paragraph>
      Custom scripts allow you to run a file on the execution environment before a test config run. They can execute any necessary Git commands to prepare the system, initialize data, set the system to a known state, or integrate with other version control systems.
    </Paragraph>
    <br />
    <Paragraph>
      To stop using custom scripts in any test configs, make sure no default custom script is set.
    </Paragraph>
    <br />
    <LinkToCustomScriptDoc />
  </>

export default TestConfigCustomScriptsDescription
